<template>
  <div id="app">
    <!-- <transition id="app"><router-view/></transition> -->
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  created() {
    //router.addRoutes();
    this.$Loading.config({
      color: '#2ce301',
      failedColor: '#f0ad4e',
      height: 2
    });
  },
  mounted(){
    var that=this;
    var login_token = window.localStorage.getItem('token');
    var login = window.localStorage.getItem('login');
    that.$myhttp.get('admin/login_user?shuanx=33&login_token='+login_token+"&login="+login,{
       'Content-Type': 'application/json'
    }).then(backdata=>{ // 异步执行成功后
        if(backdata.data == 2){
          that.$router.push({name:'login'});
        }
    });
  },
}
</script>

<style>

  html {
    overflow-y: auto !important;
  }

#app {
/*  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%; */
  color: #000000 !important;
  background-color: rgb(229, 228, 228);
}
.cdj_td{
  display:flex;
  justify-content: center;
  align-items:center;
  font-size: 14px;
}
::-webkit-scrollbar {
  width: 14px;
  height: 16px;
}

::-webkit-scrollbar-track,
::-webkit-scrollbar-thumb {
  border-radius: 999px;
  border: 5px solid transparent;
}

::-webkit-scrollbar-track {
  box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.2) inset;
}

::-webkit-scrollbar-thumb {
  min-height: 20px;
  background-clip: content-box;
  box-shadow: 0 0 0 5px rgba(0, 0, 0, 0.2) inset;
}

::-webkit-scrollbar-corner {
  background: transparent;
}
.demo-spin-icon-load{
    animation: ani-demo-spin 1s linear infinite;
}
@keyframes ani-demo-spin {
    from { transform: rotate(0deg);}
    50%  { transform: rotate(180deg);}
    to   { transform: rotate(360deg);}
}
.demo-spin-col{
    height: 100px;
    position: relative;
}
.loading{
  display: flex;
  justify-content: center;
  align-items: center;
  height: 90%;
  position: fixed;
  width: 85%;
}
.ivu-spin-fix {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 8;
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0);
}
.cdj_input{
  margin-top: 5px;
}
.cdj_span{
  color: red;
}
.cdj_margin_span{
  margin-top: 10px;
}
.cdj_el_select{
  width: 100%;
}
.d-flex-left {
    margin-right: 10px;
    border-right: 1px solid #eee;
    padding-right: 10px;
    width: 250px !important;
}
.ti {
    margin: 0 !important;
}
.d-flex-right {
  flex: 1;
  margin-top: 10px !important;
  overflow-x:hidden !important;
}
/* 框架内的字体 */
.el-descriptions-item__label.is-bordered-label {
    color: #151516 !important;
}
.el-table thead {
    color: #4c4949 !important;
    font-weight: 500 !important;
}
.el-table {
    color: #000000 !important;
}
.el-descriptions__body {
    color: #000000 !important;
}
.el-tree {
    color: #000000 !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue